import { v4 as uuid } from 'uuid';
import { Filter, Mode, AllPossibleModes, FilterType } from '@/filter/types';

const initialModeForType = (type: FilterType, allowedModes?: AllPossibleModes): Mode => {
  if (type === 'item') {
    // If modes are restricted, check for hasany or return first allowed mode
    if (!allowedModes || allowedModes?.hasany) {
      return 'hasany';
    }

    return Object.keys(allowedModes)[0] as Mode;
  }

  return 'contains';
};

export const createFilter = (name: string, type: FilterType, allowedModes?: AllPossibleModes): Filter => ({
  name,
  type,
  id: uuid(),
  value: {
    mode: initialModeForType(type, allowedModes),
  },
});
